module.exports = __webpack_public_path__ + "html/notifications.3d9121.html";


/*****************
 ** WEBPACK FOOTER
 ** /mnt/jenkins/jobs/master/workspace/core/client/common/Notifications/notifications.html
 ** module id = 489
 ** module chunks = 0 1 2 3 5 11
 **/